import { preloadSounds, unlockAudioOnFirstInteraction } from './src/lib/soundManager'

export const onClientEntry = () => {
  preloadSounds()
  unlockAudioOnFirstInteraction()
}

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  window.scrollTo(0, 0);
  requestAnimationFrame(() => {
    window.scrollTo(0, 0);
  });
  return false;
};
